import { useEffect, useState } from 'react';
import { CssPropertyType, DefaultClient } from '../../types';
import { SpacingDataResult } from '../types';
import { getSpacingData } from '../services/spacingDataService';

export const useSpacingData = (
  clients: DefaultClient[],
  allowedStyles: CssPropertyType[],
) => {
  const [data, setData] = useState<SpacingDataResult | null>(null);

  useEffect(() => {
    (async () => {
      if (clients.length > 0) {
        try {
          setData(await getSpacingData(clients, allowedStyles));
        } catch (error) {
          console.error('Failed to fetch spacing data:', error);
        }
      }
    })();
  }, [clients, allowedStyles]);

  return data;
};
